import { AddressBadge, MockLoadingTable } from '@/components/molecules'
import { DeleteIcon, RepeatIcon, SettingsIcon } from '@chakra-ui/icons'
import {
  Box,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react'

export const ConsumersTable = ({
  consumers = [],
  isLoading,
  onConsumerDelete,
  onConsumerTest,
}) => {
  return isLoading ? (
    <MockLoadingTable headers={['Address', 'Actions']} />
  ) : (
    <>
      {consumers.length ? (
        <TableContainer>
          <Table size={['sm', 'md']}>
            <Thead>
              <Tr>
                <Th>Address</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>

            <Tbody>
              {consumers?.map(({ address }, index) => (
                <Tr key={index}>
                  <Td>
                    <AddressBadge
                      address={address}
                      fullAddress={true}
                      withCopy={true}
                    />
                  </Td>
                  <Td>
                    <Menu>
                      <MenuButton
                        as={IconButton}
                        icon={<SettingsIcon />}
                        variant={'outline'}
                        _hover={{ bg: 'primary.100' }}
                      />
                      <Portal>
                        <MenuList>
                          <MenuItem
                            onClick={() =>
                              onConsumerTest({ consumerAddress: address })
                            }
                            iconSpacing={2}
                            icon={<RepeatIcon />}
                          >
                            Test Consumer
                          </MenuItem>
                          <MenuItem
                            onClick={() =>
                              onConsumerDelete({ consumerAddress: address })
                            }
                            iconSpacing={2}
                            icon={<DeleteIcon />}
                            color={'red'}
                          >
                            Delete Consumer
                          </MenuItem>
                        </MenuList>
                      </Portal>
                    </Menu>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      ) : (
        <Box>
          <Text>No consumers found.</Text>
          <Text>Add a consumer to get started.</Text>
        </Box>
      )}
    </>
  )
}
